// HumanityClub
import React from 'react';
import HumanityClass6to72023 from 'views/HumanityClass6to72023';

const HumanityClubPage = () => {
  return <HumanityClass6to72023 />;
};

export default HumanityClubPage;
